@let isMobileVal = shellState.isMobile();
@let isMinimalLayoutVal = shellState.isMinimalLayout();
@let isSettingsViewVal = isSettingsView();
@let isSidebarAvailablVal = isSidebarAvailable();

@let walkthroughIds = componentsWalkthroughId();

@let navTemplate = isSettingsViewVal ? settingsNavSidebarTpl : mainNavSidebarTpl;

<rt-icons-container />

<div class="banner">
  <ng-content select="banner" />
</div>

<div class="topbar">
  <div class="topbar-start">
    @if (isMobileVal || isMinimalLayoutVal) {
      <tlc-app-switcher-next [style.flex]="0" [walkthroughId]="walkthroughIds.appSwitcher" />
    }

    <div class="topbar-start-label" [style.left.px]="appSwitcherTriggerOffset()">
      <ng-content select="topbar-start-label" />
    </div>
  </div>

  <div class="topbar-center">
    @if (isSettingsViewVal) {
      <ng-content select="settings-topbar-center" />
    } @else {
      <ng-content select="topbar-center" />
    }
  </div>

  <div class="topbar-end">
    @if (isSettingsViewVal) {
      <ng-content select="settings-topbar-end" />
    } @else {
      <ng-content select="topbar-end" />
    }
  </div>
</div>

@if (isSidebarAvailablVal) {
  <ng-container [ngTemplateOutlet]="navTemplate" />
}

<div class="main">
  <ng-content select="main" />
</div>

@if (isMobileVal) {
  <div class="bottom-bar">
    <ng-content select="bottom-bar" />
  </div>
}

<ng-template #mainNavSidebarTpl>
  <tlc-main-navigation
    (appSwitcherWidthChange)="appSwitcherTriggerOffset.set($event)"
    [shouldExpandNavOnHover]="shouldExpandNavOnHover()"
    [navigationWalkthroughId]="walkthroughIds.navigation"
    [appSwitcherWalkthroughId]="walkthroughIds.appSwitcher"
  />
</ng-template>

<ng-template #settingsNavSidebarTpl>
  <tlc-settings-navigation (appSwitcherWidthChange)="appSwitcherTriggerOffset.set($event)" />
</ng-template>

@if (!isMobileVal) {
  <hr-assistant />
}
